const removeDocumentMask = (value?: string): string => {
  if (!value) {
    return '';
  }
  return value.replace(/\D/g, '');
};

export default removeDocumentMask;
